<template>
    <gz-auth-view-template :bc="false" contentClass="gz-auth-view-template__content_inner">
        <section v-if="sheltersListIsEmpty === 'empty'" slot="content">
            <GZ-BaseButton 
                value="добавить помещения" 
                icon="icon-plus" 
                class="gz-button_default gz-button_accent" 
                @click="$router.push(`/admin/address/${$route.params.id}/edit`)"
            />
        </section>     

        <section slot="content">
            <table class="gz-table">
                <thead class="gz-table__head">
                    <tr class="gz-table__filter-labels">
                        <td class="gz-table__filter-label"><span>Подъед</span></td>
                        <td class="gz-table__filter-label"><span>Этаж</span></td>
                        <td class="gz-table__filter-label"><span>№ Кв.</span></td>
                        <td class="gz-table__filter-label"><span>Собственник</span></td>
                        <td class="gz-table__filter-label"><span>Стояк</span></td>
                        <td class="gz-table__filter-label"><span>Сечение</span></td>
                        <td class="gz-table__filter-label"><span>ДК</span></td>
                        <td class="gz-table__filter-label"><span>ВК</span></td>
                        <td class="gz-table__filter-label"><span>Материалы</span></td>
                        <td class="gz-table__filter-label"><span>Котел</span></td>
                        <td class="gz-table__filter-label"><span>ГК</span></td>
                        <td class="gz-table__filter-label"><span>ПК</span></td>
                        <td class="gz-table__filter-label"><span>Счетчик</span></td>
                        <td class="gz-table__filter-label"></td>
                    </tr>
                    <tr class="gz-table__filter">
                        <td>
                            <GZ-TextInput 
                                @value="filters.porch = $event"
                                :disabled="true"/>
                        </td>
                        <td>
                            <GZ-TextInput 
                                @value="filters.level = $event"
                                :disabled="true"/>
                        </td>
                        <td style="display: flex">
                            <GZ-TextInput 
                                @value="filters.number.value = $event"/>
                            <button @click="changeNumberOrder()" style="min-height: 50px">
                                <span :class="{'icon-chevron-down': numberOrder === 'asc', 'icon-chevron-up': numberOrder === 'desc'}"></span>
                            </button>
                        </td>
                        <td>
                            <GZ-TextInput 
                                @value="filters.owner = $event"/>
                        </td>
                        <td>
                            <GZ-TextInput 
                                @value="filters.riser = $event"
                                :disabled="true"/>
                        </td>
                        <td>
                            <GZ-TextInput 
                                @value="filters.size = $event"
                                :disabled="true"/>
                        </td>
                        <td>
                            <GZ-TextInput 
                                @value="filters.dk = $event"
                                :disabled="true"/>
                        </td>
                        <td>
                            <GZ-TextInput 
                                @value="filters.vk = $event"
                                :disabled="true"/>
                        </td>
                        <td>
                            <GZ-TextInput 
                                @value="filters.construction = $event"
                                :disabled="true"/>
                        </td>
                        <td>
                            <GZ-TextInput 
                                @value="filters.boiler = $event"
                                :disabled="true"/>
                        </td>
                        <td>
                            <GZ-TextInput 
                                @value="filters.waterHeater = $event"
                                :disabled="true"/>
                        </td>
                        <td>
                            <GZ-TextInput 
                                @value="filters.stoveType = $event"
                                :disabled="true"/>
                        </td>
                        <td>
                            <GZ-TextInput 
                                @value="filters.counter = $event"
                                :disabled="true"/>
                        </td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    <tr 
                        v-for="(item, $index) in sheltersListComputed" 
                        :key="$index"
                        @delete-property="deleteProperty($index)"
                        @click="$router.replace({path: '/admin/shelter/' + item.id + '/schedule'})"
                        class="gz-table__row gz-table__row_secondary-color">
                        <td><span>{{ item.attributes.porch }}</span></td>
                        <td><span>{{ item.attributes.level }}</span></td>
                        <td><span>{{ item.attributes.number }}</span></td>
                        <Owner :id="item.attributes.profid" class="gz-table__col__user"/>
                        <td><span>{{ item.attributes.riser }}</span></td>
                        <td><span>{{ item.attributes.size }}</span></td>
                        <td><span>{{ item.attributes.dk }}</span></td>
                        <td><span>{{ item.attributes.vk }}</span></td>
                        <td>
                            <div v-if="item.attributes.constructionDescr" class="gz-table__col__info-icon">
                                <span class="icon-bubbles2" v-tooltip="item.attributes.constructionDescr"></span>
                            </div>
                            <ul style="font-size: .7rem">
                                <li 
                                    v-for="(constr, index) in item.attributes.construction"
                                    :key="index"
                                    :style="index !== item.attributes.construction.length - 1 && item.attributes.construction.length > 1 ? 'margin-bottom: 8px' : ''"
                                >{{ mapType(constr, $store.getters['filtersBuildingMaterial']) }}</li>
                            </ul>
                        </td>
                        <td>
                            <div v-if="item.attributes.boilerList.length > 1" class="gz-table__col__info-icon">
                                <span>{{ item.attributes.boilerList.length }}</span>
                            </div>
                            <div
                                v-for="(boiler, index) in item.attributes.boilerList"
                                :key="index" 
                                class="gz-col-inner__device-type"
                            >
                                <span style="margin-bottom: 3px">
                                    <strong>Тип:&nbsp;</strong>{{ mapType(boiler.type, $store.getters['filterBoilerType']) }}
                                </span>
                                <span>
                                    <strong>Назв:&nbsp;</strong>{{ boiler.descr }}
                                </span>
                            </div>
                        </td>
                        <td>
                            <div v-if="item.attributes.waterHeaterList.length > 1" class="gz-table__col__info-icon">
                                <span>{{ item.attributes.waterHeaterList.length }}</span>
                            </div>
                            <div
                                v-for="(waterHeater, index) in item.attributes.waterHeaterList"
                                :key="index" 
                                class="gz-col-inner__device-type"
                            >
                                <span style="margin-bottom: 3px">
                                    <strong>Тип:&nbsp;</strong>{{ mapType(waterHeater.type, $store.getters['filterWaterHeaterType']) }}
                                </span>
                                <span>
                                    <strong>Назв:&nbsp;</strong>{{ waterHeater.descr }}
                                </span>
                            </div>
                        </td>
                        <td>
                            <div v-if="item.attributes.stoveList.length > 1" class="gz-table__col__info-icon">
                                <span>{{ item.attributes.stoveList.length }}</span>
                            </div>
                            <div
                                v-for="(stove, index) in item.attributes.stoveList"
                                :key="index" 
                                class="gz-col-inner__device-type"
                            >
                                <span style="margin-bottom: 3px">
                                    <strong>Тип:&nbsp;</strong>{{ mapType(stove.type, $store.getters['filterStoveType']) }}
                                </span>
                                <span>
                                    <strong>Назв:&nbsp;</strong>{{ stove.descr }}
                                </span>
                            </div>
                        </td>
                        <td>
                            <div v-if="item.attributes.gasCounterList.length > 1" class="gz-table__col__info-icon">
                                <span>{{ item.attributes.gasCounterList.length }}</span>
                            </div>
                            <div
                                v-for="(gasCounter, index) in item.attributes.gasCounterList"
                                :key="index" 
                                class="gz-col-inner__device-type"
                            >
                                <span><strong>Назв:&nbsp;</strong>{{ gasCounter.descr }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="gz-col-delete-icon" @click.stop="deleteProperty($index)">
                                <span class="icon-bin"></span>
                            </div>
                            <NextCheckupDate 
                                v-if="item.attributes.nextCheckupDate" 
                                :date="item.attributes.nextCheckupDate" 
                                :isActive="false"
                            />
                        </td>
                    </tr>
                    <infinite-loading 
                        @infinite="infiniteHandler"
                        :identifier="infiniteId" 
                    ></infinite-loading>
                </tbody>
            </table>
        </section>
    </gz-auth-view-template>
</template>

<script>
import mapType from '@/mixins/utils/types-mapper'
import NextCheckupDate from '@/components/custom/admin/views/addresses/BaseNextCheckupDate'
import Owner from './Owner'

export default {
    name: 'SingleAddressViewAll',

    mixins: [mapType],
    components: {
        NextCheckupDate,
        Owner
    },
    data() {
        return {
            sheltersList: [],
            sheltersListIsEmpty: '',
            filters: {
                id: {
                    value: ''
                },
                porch: {
                    value: ''
                },
                level: {
                    value: ''
                },
                riser: {
                    value: ''
                },
                number: {
                    value: ''
                },
                owner: {
                    value: ''
                },
                size: {
                    value: ''
                },
                dk: {
                    value: ''
                },
                vk: {
                    value: ''
                },
                construction: {
                    value: ''
                },
                boiler: {
                    value: ''
                },
                waterHeater: {
                    value: ''
                },
                stoveType: {
                    value: ''
                },
                counter: {
                    value: ''
                }
            },

            numberOrder: 'asc',

            page: 0,
            infiniteId: +new Date()
        }
    },
    computed: {
        sheltersListComputed() {
            return this.sheltersList
        }
    },
    
    methods: {
        infiniteHandler($state) {
            this.$axios('property', {
                params: {
                    pg: this.page, 
                    batch: 2,
                    buildingId: this.$route.params.id,
                    sort: 'number',
                    order: this.numberOrder,
                    number: this.filters.number.value
                }
            })
            .then(({data}) => {
                if (data.data.length) {
                    this.page += 1;
                    this.sheltersList.push(...data.data)

                    $state.loaded()
                } else {
                    $state.complete();
                }
            })            
            .catch(err => {
                console.error('Ошибка вывода списка объектов: ', err)
            })
        },
        async deleteProperty(index) {
            if (confirm('Вы уверенны, что хотите удалить помещение?')) {
                let propertyData = this.sheltersList[index]
                propertyData.attributes.status = 'DELETED'
    
                try {
                    const response = await this.$axios.patch('property/' + propertyData.id, {
                        data: {
                            type: 'property',
                            attributes: propertyData.attributes
                        }
                    })
                    
                    location.reload()

                } catch(e) {
                    console.log(e)
                }
            }
        },
        changeNumberOrder() {
            if (this.numberOrder === 'asc') {
                
                this.numberOrder = 'desc'

                return true
            } else if (this.numberOrder === 'desc') {
                
                this.numberOrder = 'asc'
                
                return false
            }
        }
    },
    watch: {
        filters: {
            handler() {
                this.page = 0
                this.sheltersList = []
                this.infiniteId += 1
            },
            deep: true
        }, 
        numberOrder: {
            handler() {
                this.page = 0
                this.sheltersList = []
                this.infiniteId += 1
            }
        } 
    }
}
</script>